// ============================================================
// fondos/efectos/geometric.js — «Geométrico»: triángulos y hexágonos de trazo que flotan y giran
// (efecto de LIENZO)
//
// Portado de `vendor/bg/geometric-bg.js` en la F2b del P3 con el MISMO dibujo (el test de espejo lo
// compara llamada a llamada con la clase de siempre). La velocidad —la de traslación y la de giro—
// va por `dt` (`comun.js::PASO`). El alfa del trazo es el tope del catálogo (`alfaMax`, F3).
// ============================================================

import { pasos, rgbDe } from './comun.js';

function poligono(ctx, x, y, radius, sides, angle) {
    ctx.beginPath();
    for (let i = 0; i < sides; i++) {
        const a = angle + (i * Math.PI * 2) / sides;
        const px = x + Math.cos(a) * radius;
        const py = y + Math.sin(a) * radius;
        if (i === 0) ctx.moveTo(px, py);
        else ctx.lineTo(px, py);
    }
    ctx.closePath();
    ctx.stroke();
}

export default {
    crear(ctx, e) {
        const p = e.params;
        const speedMult = p.speed != null ? (0.4 + (p.speed - 1) * (2.6 / 9)) : 1.0;
        const n = e.tactil ? 10 : 25;
        const formas = [];
        for (let i = 0; i < n; i++) {
            formas.push({
                x: e.azar(),
                y: e.azar(),
                vx: (e.azar() - 0.5) * 0.1 * speedMult,
                vy: (e.azar() - 0.5) * 0.1 * speedMult,
                radius: 20 + e.azar() * 60,
                sides: e.azar() > 0.5 ? 3 : 6,
                angle: e.azar() * Math.PI * 2,
                vAngle: (e.azar() - 0.5) * 0.02 * speedMult,
            });
        }
        return { w: e.w, h: e.h, rgb: rgbDe(e.c1), alfa: e.alfa, formas: formas };
    },

    redimensionar(s, w, h) {
        s.w = w;
        s.h = h;
    },

    dibujar(s, ctx, t, dt) {
        const k = pasos(dt);
        const rgb = s.rgb;
        const W = s.w;
        const H = s.h;

        ctx.lineWidth = 1;
        ctx.strokeStyle = `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${s.alfa})`;
        s.formas.forEach(function (shape) {
            if (k > 0) {
                shape.x += shape.vx * k / W;
                shape.y += shape.vy * k / H;
                shape.angle += shape.vAngle * k;
                // Salen por un lado y vuelven por el otro, con margen para que no aparezcan de golpe.
                if (shape.x < -0.2) shape.x = 1.2;
                if (shape.x > 1.2) shape.x = -0.2;
                if (shape.y < -0.2) shape.y = 1.2;
                if (shape.y > 1.2) shape.y = -0.2;
            }
            poligono(ctx, shape.x * W, shape.y * H, shape.radius, shape.sides, shape.angle);
        });
    },
};
